import styled from 'styled-components'

import theme from 'theme_'
import { Dropdown } from 'components/Input'
import { Font14, H2 } from 'components/Typography'
import { WhiteBlock } from 'components/Layout'

export const EventsFormBottomSizes = {
  tablet: '192px',
  tabletLandscape: '124px',
}

export const HomeServicesContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
`

export const HomeServicesTitle = styled(H2)`
  font-weight: 900;
  margin-bottom: 16px;
`

export const HomeServicesBody = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-column-gap: 16px;
  position: relative;
  @media ${theme.devices.tablet} {
    grid-template-columns: 240px calc(100% - 16px - 240px);
  }
  @media ${theme.devices.tabletLandscape} {
    grid-template-columns: 351px calc(100% - 16px - 351px);
  }
`

export const HomeServicesEventsWrapper = styled(WhiteBlock)`
  height: min-content;
  display: none;
  position: sticky;
  right: 0;
  top: calc(${theme.sizes.headerHeight} + 16px);
  padding: 0;
  transition: all 0.3s ease;
  @media ${theme.devices.tablet} {
    display: flex;
  }
  @media ${theme.devices.tabletLandscape} {
    display: flex;
  }
`

export const HomeServicesTableContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const HomeServicesFiltersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  gap: 10px;
  @media ${theme.devices.tablet} {
    flex-direction: row;
    flex-wrap: wrap;
  }
  @media ${theme.devices.tabletLandscape} {
    flex-wrap: nowrap;
  }
`

export const HomeServicesFilterDropdown = styled(Dropdown)`
  background: ${theme.colors.white};
  box-shadow: inset 0 0 0 1px ${theme.colors.lightGrey};
  border-radius: 8px;
  display: flex;
  order: 1;
  transition: all 0.3s ease;
  font-weight: normal;
  ${Font14};
  width: 100%;

  :focus-within {
    box-shadow: inset 0 0 0 1px ${theme.colors.horizonOrange};
  }

  .select__dropdown-indicator {
    color: ${theme.colors.otterWarmBlack};
  }

  .select__menu {
    position: absolute;

    background: ${theme.colors.white};
    box-shadow: 0 4px 40px ${theme.colors.commonShadow};
    border-radius: 8px;
  }

  .select__control--is-focused {
    border: none;
    box-shadow: none;
  }

  .select__control {
    width: 100%;
    border: none;
    background: none;

    &:hover {
      border: none;
    }
  }

  @media ${theme.devices.tabletLandscape} {
    width: 256px;
  }
`

export const HomeServicesSearchWrapper = styled.div`
  display: flex;
  align-items: center;
  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.02);
  border-radius: 8px;
  flex-grow: 1;
  width: 100%;
  order: 0;
  @media ${theme.devices.tablet} {
    order: 2;
  }
`

export const HomeServicesInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 96px;
  color: ${theme.colors.darkeyGrey};
  background: ${theme.colors.white};
  border-radius: 8px;
  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.02);
`
